import {AttributeDto} from '@kontactless/admin-api/attribute/attribute.dto';
import {callApi} from './api';

export const fetchAllAttributesRequest = async (token: string): Promise<AttributeDto[]> => {
  return callApi<AttributeDto[]>('/attributes', {token}).then(({data}) => data);
};
